import React from "react";
import { Skeleton } from "@heroui/skeleton";

export default function StockOwnershipSkeleton() {
  return (
    <div className="p-5 mb-4 bg-white shadow-md rounded-lg border">
      {/* Mimic the title of the table */}
      <Skeleton className="h-6 w-1/3 mb-4 rounded" />

      {/* Skeleton for the table header */}
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr>
              <th className="px-4 py-2">
                <Skeleton className="h-4 w-24 mb-2 rounded" />
              </th>
              <th className="px-4 py-2">
                <Skeleton className="h-4 w-24 mb-2 rounded" />
              </th>
              <th className="px-4 py-2">
                <Skeleton className="h-4 w-24 mb-2 rounded" />
              </th>
              <th className="px-4 py-2">
                <Skeleton className="h-4 w-24 mb-2 rounded" />
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Skeletons for the rows */}
            {[...Array(10)].map((_, index) => (
              <tr key={index}>
                <td className="px-4 py-2">
                  <Skeleton className="h-4 w-48 rounded" />
                </td>
                <td className="px-4 py-2">
                  <Skeleton className="h-4 w-36 rounded" />
                </td>
                <td className="px-4 py-2">
                  <Skeleton className="h-4 w-36 rounded" />
                </td>
                <td className="px-4 py-2">
                  <Skeleton className="h-4 w-24 rounded" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Load More button skeleton */}
      <div className="flex justify-center mt-4">
        <Skeleton className="h-10 w-32 rounded" />
      </div>
    </div>
  );
}
